import React from "react";
import { motion, AnimatePresence } from "framer-motion";

interface FAQItemProps {
  question: string;
  answer: string;
  action: string;
  isOpen: boolean;
  onClick: () => void;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer, isOpen, action, onClick }) => {
  return (
    <div className="faq-item">
      {/* Pregunta clickeable */}
      <div
        className="faq-question bg-gray-100 cursor-pointer p-4 font-semibold flex items-center hover:bg-gray-200 transition"
        onClick={onClick}
      >
        {/* Botón + a la izquierda */}
        <motion.span
          //animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.15, ease: "easeOut" }}
          className="text-xl font-bold mr-3"
        >
          +
        </motion.span>

        <span>{question}</span>
      </div>

      {/* Respuesta animada */}
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="faq-answer px-4 pt-2 pb-4 overflow-hidden bg-white"
          >
            <div className="answer" dangerouslySetInnerHTML={{ __html: answer }} />
            <div className="action" dangerouslySetInnerHTML={{ __html: action }} />            
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FAQItem;
